import React from 'react';
interface MiniSparklineProps {
  data: number[];
  color?: string;
  className?: string;
}
export function MiniSparkline({
  data,
  color = '#8eff01',
  className = ''
}: MiniSparklineProps) {
  if (!data || data.length === 0) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  // Map data to SVG coordinates (0-100 width, 0-20 height)
  // Y is inverted because SVG 0,0 is top-left
  const points = data.map((d, i) => {
    const x = i / (data.length - 1) * 100;
    const y = 20 - (d - min) / range * 18 - 1; // 1px padding top/bottom
    return `${x},${y}`;
  }).join(' ');
  return <div className={`w-full h-[20px] ${className}`} data-id="element-296" data-mp="2b5pioj6p61wm">
      <svg viewBox="0 0 100 20" className="w-full h-full overflow-visible" preserveAspectRatio="none" data-id="element-297" data-mp="2675vkfgdak2o">
        <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" data-id="element-298" data-mp="217jji9c9z9vg" />
      </svg>
    </div>;
}